import { render, staticRenderFns } from "./StudentApplicationStatus.vue?vue&type=template&id=631b7d18&"
import script from "./StudentApplicationStatus.vue?vue&type=script&lang=ts&"
export * from "./StudentApplicationStatus.vue?vue&type=script&lang=ts&"
import style0 from "./StudentApplicationStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports